import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=bbf296a2&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=bbf296a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf296a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
